import everflowStorage from "./storage"
import {EverflowStore, EverflowStoreItem} from "./storage/interface"

class Everflow {
  async setTid(dealId: string, tid: string) {
    const data = await this.get()
    data[dealId] = {tid}
    await everflowStorage.set(data)
  }

  async getForDealId(dealId: string): Promise<EverflowStoreItem | null> {
    const data = await this.get()
    const item = data[dealId]
    if (!item) {
      return null
    }

    return item
  }

  async clearForDealId(dealId: string): Promise<void> {
    const data = await this.get()
    delete data[dealId]
    await everflowStorage.set(data)
  }

  async get(): Promise<EverflowStore> {
    return everflowStorage.get()
  }
}

const everflowTracker = new Everflow()

export default everflowTracker
